import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Modal } from '@carbon/react';
import { usePlanLimit } from 'src/states/planLimit';

/** Mounted once in MainLayout; any 402 PLAN_* anywhere in the app opens it. */
export default function UpgradeModal() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const error = usePlanLimit((s) => s.error);
  const close = usePlanLimit((s) => s.close);
  if (!error) return null;
  const body =
    error.code === 'PLAN_LIMIT'
      ? t('billing.upgrade.limit', { limit: error.limit, resource: t(`billing.resource.${error.resource}`) })
      : t('billing.upgrade.feature', { feature: t(`billing.feature.${error.feature}`) });
  return (
    <Modal
      open
      modalHeading={t('billing.upgrade.title')}
      primaryButtonText={t('billing.upgrade.cta')}
      secondaryButtonText={t('billing.upgrade.notNow')}
      onRequestClose={close}
      onRequestSubmit={() => {
        close();
        navigate('/settings/organization/billing');
      }}
    >
      <p>{body}</p>
    </Modal>
  );
}
